import { HeroActions } from './HeroActions';
import { HeroIdentity } from './HeroIdentity';
import { HeroBackground } from './HeroBackground';

export const HeroSection = ({ handleWhatsAppClick, handleCallClick }) => (
<section id="accueil" data-testid="home-hero" className="hero-stage">
        <HeroBackground />
        
<div className="hero-content">
            <HeroIdentity />
            
<div className="hero-description"><p className="text-base md:text-lg text-gray-200 leading-relaxed mb-3">
                Maître Diamma est un <strong className="text-yellow-400">marabout africain authentique</strong> et <strong className="text-white">sorcier vaudou haïtien</strong>{' '}
                reconnu dans toute la Guadeloupe. Héritier d'une longue lignée de maîtres traditionalistes africains, 
                il pratique les rituels ancestraux de vaudou avec plus de 20 ans d'expérience.
              </p></div>
<HeroActions handleWhatsAppClick={handleWhatsAppClick} handleCallClick={handleCallClick} />
            <p className="mt-6 md:mt-8 text-gray-400 text-xs md:text-sm px-4">
              📞 Réponse rapide garantie • Consultation discrète • Résultats garantis
            </p></div>
</section>
);
